import { TableContainer, TablePagination } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import { SearchBar } from "components/Common/SearchBar"
import { useAppSelector } from "hooks"
import { useState } from "react"
import type { IUserGroup } from "types/userGroupTypes"
import { UserGroupListItemMenu } from "./UserGroupListItemMenu"

export function UserGroupList() {
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const [searchText, setSeachText] = useState<string>("")

  const userGroups = useAppSelector((state) => state.usergroup.userGroups)
  const users = useAppSelector((state) => state.users.users)

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const filterUsers = (value: string, groups: Array<IUserGroup>): Array<IUserGroup> => {
    const filteredGroups = groups.filter((usergroup) => {
      return usergroup.name.toLowerCase().includes(value.toLowerCase())
    })

    return filteredGroups
  }

  return (
    <TableContainer>
      <SearchBar onChange={(value: string) => setSeachText(value)} />
      <div style={{ minHeight: "280px" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Users</TableCell>
              <TableCell align="right" padding="checkbox"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filterUsers(searchText, userGroups)
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((userGroup) => (
                <TableRow key={userGroup.id} hover>
                  <TableCell>{userGroup.name}</TableCell>
                  <TableCell>
                    {users.filter((x) => x.userGroupId === userGroup.id).length}
                  </TableCell>
                  <TableCell align="right" onClick={(e) => e.stopPropagation()}>
                    <UserGroupListItemMenu userGroup={userGroup} />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </div>
      <TablePagination
        component="div"
        rowsPerPageOptions={[5, 10, 25]}
        count={filterUsers(searchText, userGroups).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </TableContainer>
  )
}
